import React, { useEffect, useRef } from "react";

// Same trust model / execution model as ui_actions.sip_client_script
// (frontend/src/runtime/sipRuntime.js) -- admin-authored script, run via
// new Function(), given a small "sip" helper object rather than raw DOM/
// React internals.
const CustomScriptWidget = ({ widget, apiBaseUrl, token, navigate }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const script = widget.props?.script;
    if (!script || !containerRef.current) return;

    const sip = {
      container: containerRef.current,
      apiBaseUrl,
      token,
      navigate,
      data: widget.data,
    };

    try {
      const fn = new Function("sip", script);
      fn(sip);
    } catch (e) {
      console.error("Custom script widget failed:", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widget.id]);

  return <div ref={containerRef} />;
};

export default CustomScriptWidget;
